import { PublicCallback } from 'globals/types';
import { getTranslatedSatisfactionForm } from 'core_main/api/satisfaction';
import { handleError } from 'globals/errors';
import { GetTranslatedSatisfactionFormParameters } from './types';

export const getTranslatedSatisfactionFormSdk = (
  parameters: GetTranslatedSatisfactionFormParameters,
  cb?: PublicCallback,
) => {
  const { satisfactionId, lang } = parameters;

  return getTranslatedSatisfactionForm(satisfactionId, lang)
    .then((response) => {
      if (typeof cb === 'function') {
        cb(response);
      }
      return response;
    })
    .catch((error) => {
      if (typeof cb === 'function') {
        cb(null, error);
      }
      handleError(error, {
        message: 'Failed to get translated satisfaction form',
      });
    });
};
